import {getServerTexts as getTexts, initTexts, texts} from '../../../Localization/texts';

const entity = 'UI_EOY';

const en = {
    next_button_label: "Let's go",
    continue_label: "Let's continue",
    reminder_dismiss_label: 'Remind me later',
    reminder_stage_0_title: 'Year-End Wizard: Reaching the Year-End',
    reminder_stage_0_instructions:
        'Let’s begin the year-end process, to ensure a smooth transition to the new fiscal year.',
    reminder_stage_0_name: 'Reaching the Year-End',
    reminder_stage_1_title: 'Year-End Wizard: Last Day of the Year',
    reminder_stage_1_instructions:
        'It’s the last working day of the year. Let’s continue the year-end process.',
    reminder_stage_1_name: 'Last day of the Year',
    reminder_stage_2_title: 'Year-End Wizard: Start of the Year',
    reminder_stage_2_instructions: 'Let’s continue to the final stage in the year-end process.',
    reminder_stage_2_name: 'Start of the year',
    step_waiting: 'Step {step_name} is waiting for you.',
    reminder_step_awaiting_next_btn: 'Show me',
    reminder_step_assign_next_btn: 'Continue',
    reminder_step_assign_title: '{User full name} assigned this step to you.',
    reminder_step_assign_instructions: 'Click Continue to proceed to step: "XXX".',
    reminder_step_completed_title: 'Year-End Wizard: {stage_name}',
    reminder_step_completed_instructions1: 'Step {step_name} was completed by {user_name}',
    reminder_step_completed_instructions2: 'Step {step_name} is waiting for you.',
    step_completed_title: 'You have completed the step.',
    step_completed_description: 'We will let "XXX" know.',
    done: 'Done'
};

const he = {
    next_button_label: "Let's go",
    continue_label: 'להמשיך',
    reminder_dismiss_label: 'תזכירו לי אח”כ',
    reminder_stage_0_title: 'תהליך מעבר שנה: לקראת סוף השנה',
    reminder_stage_0_instructions: 'השנה כמעט נגמרה, בואו נתחיל בתהליך מעבר שנה.',
    reminder_stage_0_name: 'לקראת סוף השנה',
    reminder_stage_1_title: 'תהליך מעבר שנה: היום האחרון בשנה',
    reminder_stage_1_instructions: 'הגענו ליום העבודה האחרון בשנה. בואו נמשיך בתהליך מעבר שנה.',
    reminder_stage_1_name: 'היום האחרון בשנה',
    reminder_stage_2_title: 'תהליך מעבר שנה: תחילת שנה חדשה',
    reminder_stage_2_instructions: 'בואו נבצע את הפעולות האחרונות בתהליך מעבר השנה.',
    reminder_stage_2_name: 'תחילת שנה חדשה',
    step_waiting: 'עדיין נשארו פעולות לביצוע בתהליך מעבר שנה: {step_name} - צעד',
    reminder_step_awaiting_next_btn: 'קחו אותי לשם',
    reminder_step_assign_next_btn: 'להמשיך',
    reminder_step_assign_title: '{User full name} העביר.ה את הצעד לטיפולך.',
    reminder_step_assign_instructions: 'לחצו על כפתור “להמשיך” כדי לפתוח את הצעד: "XXX"',
    reminder_step_completed_title: 'תהליך מעבר שנה: {stage_name}',
    reminder_step_completed_instructions1: 'הצעד {step_name} הושלם על ידי משתמש {user_name}',
    reminder_step_completed_instructions2:
        'עדיין נשארו פעולות לביצוע בתהליך מעבר שנה:\n' + 'המשיכו לביצוע צעד {step_name}',
    step_completed_title: 'סיימת את הצעד בהצלחה.',
    step_completed_description: 'הודעה תשלח ל "XXX".',
    done: 'סיימתי'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'stage0_step0_name',
    2: 'close',
    3: 'stage0_step0_description',
    4: 'stage0_step0_next_button',
    5: 'remind_later',
    6: 'stage0_title',
    7: 'stage0_step1_name',
    8: 'stage0_step2_name',
    9: 'stage0_step3_name',
    10: 'assign_step_to',
    11: 'stage0_step1_title',
    12: 'stage0_step1_explanation',
    13: 'create_fiscal_year',
    14: 'open_first_period',
    15: 'open_all_periods',
    16: 'do_not_open_periods',
    17: 'add_new_period',
    18: 'next',
    19: 'stage0_step2_title',
    20: 'stage0_step2_explanation',
    21: 'show_more',
    22: 'show_less',
    23: 'stage0_step2_more_text',
    24: 'perform_in_all_companies',
    25: 'open_numeric_templates',
    26: 'stage0_step2_branches_notice',
    27: 'next',
    28: 'stage0_step3_title',
    29: 'stage0_step3_explanation',
    30: 'stage0_step3_more_text',
    31: 'working_on_it',
    32: 'stage_0_step3_links',
    33: 'done',
    34: 'stage0_step4_title',
    35: 'stage0_step4_prompt',
    36: 'stage0_step4_done',
    37: 'stage1_step0_description',
    38: 'next_button_label',
    39: 'stage1_title',
    40: 'stage1_step1_name',
    41: 'stage1_step2_name',
    42: 'stage1_step3_name',
    43: 'stage1_step4_name',
    44: 'stage1_step1_title',
    45: 'stage1_step1_explanation',
    46: 'unbalanced',
    47: 'balanced',
    48: 'all_P1_cashiers_balanced',
    49: 'refresh_data',
    50: 'stage1_step2_explanation',
    51: 'stage1_step2_more_text',
    52: 'run_report',
    53: 'stage_1_step2_links2',
    54: 'stage1_step3_explanation',
    55: 'stage1_step3_custom_next',
    56: 'stage1_step4_title',
    57: 'stage1_step4_explanation',
    58: 'reminder_dismiss_label',
    59: 'stage1_step4_run_and_save',
    60: 'stage1_step4_links',
    61: 'stage1_step5_title',
    62: 'stage1_step5_prompt',
    63: 'stage2_title',
    64: 'stage2_step1_name',
    65: 'stage2_step1_transferred',
    66: 'stage2_step1_explanation',
    67: 'stage2_step2_title',
    68: 'stage2_step2_prompt',
    69: 'assign_step_to_title',
    71: 'assign_instructions',
    72: 'assignee',
    73: 'choose_user',
    75: 'assign_btn',
    76: 'cancel_btn',
    77: 'reminder_stage_0_title',
    78: 'reminder_stage_0_instructions',
    79: 'stage1_step4_report_0',
    80: 'stage1_step4_report_1',
    81: 'stage1_step4_report_2',
    82: 'reminder_stage_0_name',
    83: 'reminder_stage_1_name',
    84: 'reminder_stage_2_name',
    85: 'reminder_stage_1_title',
    86: 'reminder_stage_1_instructions',
    87: 'reminder_stage_2_title',
    88: 'reminder_stage_2_instructions',
    89: 'step_completed_title',
    90: 'step_waiting',
    91: 'reminder_step_awaiting_next_btn`',
    92: 'reminder_step_assign_title`',
    93: 'reminder_step_assign_instructions',
    94: 'reminder_step_awaiting_next_btn',
    95: 'reminder_step_completed_title',
    96: 'reminder_step_completed_instructions1',
    97: 'reminder_step_completed_instructions2',
    98: 'step_completed_title',
    99: 'step_completed_description',
    102: 'column_description',
    103: 'column_prefix',
    104: 'column_initial_no',
    105: 'column_length',
    106: 'column_preview',
    107: 'stage0_step2_branches_notice_link',
    108: 'stage0_step2_branches_notice_continue',
    109: 'stage0_step2_branches_notice_ending',
    110: 'stage_0_step3_links2',
    111: 'stage_0_step3_link2_name',
    113: 'stage_1_step2_links',
    114: 'stage_1_step2_link2_name',
    115: 'stage_1_step2_link_name',
    116: 'stage_0_step3_link_name',
    117: 'stage_1_step1_column_cashiers',
    118: 'stage_1_step3_close_column',
    119: 'continue_label',
    120: 'stage_1_step1_several_currencies'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

initTexts(entity, fallbacks);

export default texts[entity];
